import { useSelector } from 'react-redux'
import { hasPermission } from 'store/user'

const usePermissions = (permission) =>
  useSelector((state) => {
    return hasPermission(state, permission)
  })

export default usePermissions
